import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AppSection from '@/pages/home/components/AppSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <FeaturesSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <IndexSection />
        <AppSection />
        <TopicsSection />
        <FaqSection />
        <AboutSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}